import z from 'zod';
import { SavedView } from '@rossum/api-client/savedViews';
import { GridFilterItem } from '@rossum/ui/x-data-grid-pro';

export const expectedQuerySchema = z.object({
  $and: z.array(z.record(z.unknown())),
});

export type ExpectedQuerySchema = z.TypeOf<typeof expectedQuerySchema>;

export type ParsedSavedView = Omit<SavedView, 'query'> & {
  parsedQuery: GridFilterItem[];
  query: ExpectedQuerySchema | null;
};
export type NormalizedSavedView = ParsedSavedView & {
  missingColumns: string[];
};

// An entry listed above the saved views that is not a saved view itself, so it
// has no id; the consumer decides when it is active and what selecting it does.
export type SystemView = {
  label: string;
  isActive: boolean;
  onSelect: () => void;
};
